<template>
  <div
      class="position-relative w-100 h-100"
      :class="bgLayoutMap[props.effectMode]"
      :style="{
        maxWidth:`${defaultWidth}px`,
        maxHeight:`${defaultHeight}px`
      }"
  >
    <div
        class="bg_three_slider_wrap"
    ></div>
    <div class="text_three_sensor_wrap">
      <div
          class="d-inline-flex justify-content-center w-100 h-100"
          :style="{
                  opacity: `${textOpacity}`,
                  maxHeight:`${defaultHeight/2 - 40 - 2}px`
                 }"
      >
        <div
            class="d-inline-flex flex-column justify-content-center"
            :style="{
              'padding': threeSensorMainPaddingFix[mainFontFamily] || '0',
              'margin': threeSensorMainMarginFix[mainFontFamily] || '0',
        }"
        >
          <div
              class="medium_font_wrap main_font_size"
              :class="[
                mainFontFamily,
                `main_font_size_${props.effectMode}_${textType}`
            ]"
              :style="{
                'color': changeToRgba(textFontColors.arr[0]),
                'text-shadow': `0px 3px 2px rgba(0, 0, 0, ${textShadow || '16'})`
              }"

          >
            {{ topTextContent.obj.Value }}
          </div>
          <div class="w-100" :style="{height: threeSensorMainSpaceFix[mainFontFamily] || '0'}"></div>
          <div
              class="bottom_font_wrap bottom_margin_fix sub_font_size sub_font_family d-inline-flex align-items-center flex-nowrap justify-content-center"
              :class="[
                    mainFontFamily,
                    `sub_font_size_${props.effectMode}_${textType}`,
                    `bottom_margin_fix_${mainFontFamily}_${props.effectMode}_${textType}`
                  ]"
              :style="{
                'color': changeToRgba(textFontColors.arr[1]),
                'text-shadow': `0px 3px 2px rgba(0, 0, 0, ${textShadow || '16'})`
                 }"
          >
            <span>{{ topTextContent.obj.Type }}</span>
            <span class="text_unit_p">{{ topTextContent.obj.Unit }}</span>
          </div>
        </div>
      </div>
      <div
          class="border_line_h"
          :style="{ 'backgroundColor': changeToRgba(textFontColors.arr[1]) }"
      ></div>
      <div
          class="d-inline-flex align-items-end justify-content-between w-100 h-100 pt_20px"
          :style="{
                  opacity: `${textOpacity}`,
                  maxHeight:`${defaultHeight/2 - 34 - 20}px`
                 }"
      >
        <div
            class="d-inline-flex flex-column half_w justify-content-center"
            :style="{'padding': threeSensorLeftPaddingFix[mainFontFamily] || '0'}"
        >
          <div
              class="medium_font_wrap main_font_size"
              :class="[
                mainFontFamily,
                `main_font_size_${props.effectMode}_${textType}`
            ]"
              :style="{
                'color': changeToRgba(textFontColors.arr[0]),
                'text-shadow': `0px 3px 2px rgba(0, 0, 0, ${textShadow || '16'})`
              }"
          >
            {{ leftTextContent.obj.Value }}
          </div>
          <div class="w-100" :style="{height: threeSensorSubSpaceFix[mainFontFamily] || '0'}"></div>
          <div
              class="bottom_font_wrap bottom_margin_fix sub_font_size sub_font_family d-inline-flex align-items-center flex-nowrap justify-content-center"
              :class="[
                    mainFontFamily,
                    `sub_font_size_${props.effectMode}_${textType}`,
                    `bottom_margin_fix_${mainFontFamily}_${props.effectMode}_${textType}`
                  ]"
              :style="{
                'color': changeToRgba(textFontColors.arr[1]),
                'text-shadow': `0px 3px 2px rgba(0, 0, 0, ${textShadow || '16'})`
              }"
          >
            <span>{{ leftTextContent.obj.Type }}</span>
            <span class="text_unit_p">{{ leftTextContent.obj.Unit }}</span>
          </div>
        </div>
        <div
            class="border_line_v"
            :style="{ 'backgroundColor': changeToRgba(textFontColors.arr[1]) }"
        ></div>
        <div
            class="d-inline-flex flex-column half_w justify-content-center"
            :style="{'padding': threeSensorRightPaddingFix[mainFontFamily] || '0'}"
        >
          <div
              class="medium_font_wrap main_font_size"
              :class="[
                mainFontFamily,
                `main_font_size_${props.effectMode}_${textType}`
            ]"
              :style="{
            'color': changeToRgba(textFontColors.arr[0]),
            'text-shadow': `0px 3px 2px rgba(0, 0, 0, ${textShadow || '16'})`
          }"
          >
            {{ rightTextContent.obj.Value }}
          </div>
          <div class="w-100" :style="{height: threeSensorSubSpaceFix[mainFontFamily] || '0'}"></div>

          <div
              class="bottom_font_wrap bottom_margin_fix sub_font_size sub_font_family d-inline-flex align-items-center flex-nowrap justify-content-center"
              :class="[
                    mainFontFamily,
                    `sub_font_size_${props.effectMode}_${textType}`,
                    `bottom_margin_fix_${mainFontFamily}_${props.effectMode}_${textType}`
                  ]"
              :style="{
            'color': changeToRgba(textFontColors.arr[1]),
            'text-shadow': `0px 3px 2px rgba(0, 0, 0, ${textShadow || '16'})`
          }"
          >
            <span>{{ rightTextContent.obj.Type }}</span>
            <span class="text_unit_p">{{ rightTextContent.obj.Unit }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import defaultValue from "@/utils/defaultValue";

import {ref, reactive, watchEffect, watch} from 'vue'
import changeToRgba from '@/utils/globalFunc'
import textModeTool from "@/utils/textModeTool";

const {defaultWidth, defaultHeight} = defaultValue()

const {
  bgLayoutMap,
  threeSensorMainPaddingFix,
  threeSensorLeftPaddingFix,
  threeSensorRightPaddingFix,
  threeSensorMainMarginFix,
  threeSensorMainSpaceFix,
  threeSensorSubSpaceFix,
  initMainFontFamily
} = textModeTool()

const props = defineProps(["textData", "sensorValue", 'effectMode'])
const texts = reactive(props.textData)
const textType = ref('')

const sensorJsonObj = reactive({obj: props.sensorValue}) // 取得sensor資料
const textFontColors = reactive({arr: []})
const textContent = reactive({arr: []})
const topTextContent = reactive({obj: {}})
const leftTextContent = reactive({obj: {}})
const rightTextContent = reactive({obj: {}})

const mainFontFamily = ref('')

const textShadow = ref('35%')
const textOpacity = ref('100%')

const sensorsSelectedValue = ref([])

const processTextContent = (sensorsSelected, sensorJsonObj) => {
  textContent.arr = []
  for (const sensor of sensorsSelected) {
    if (sensor === 'CoolantTemp') {
      let s = Object.assign({}, sensorJsonObj[sensor], {
        Type: 'COOL'
      })
      textContent.arr.push(s);
    } else textContent.arr.push(sensorJsonObj[sensor]);
  }
}

watchEffect(() => {
  const {
    Type,
    Layout,
    Sensors: sensorsSelected
  } = texts

  if (Type === 'None' || Type === undefined) {
    textFontColors.arr = []
    return false
  }
  textType.value = Type
  sensorsSelectedValue.value = sensorsSelected

  const {
    Shadow,
    FontFamily,
    FontColors
  } = Layout[0]
  // 取得文字顏色
  textFontColors.arr = FontColors
  // 取得文字陰影
  textShadow.value = parseInt(Shadow) >= 0 ? `${Shadow}%` : '60%'
  // 取得文字FontFamily
  if (FontFamily && FontFamily !== '') mainFontFamily.value = `font_family_${FontFamily}`
  else mainFontFamily.value = initMainFontFamily(props.effectMode)

  // 取得資料
  processTextContent(sensorsSelectedValue.value, sensorJsonObj.obj)
  topTextContent.obj = textContent.arr[0] ? textContent.arr[0] : {}
  leftTextContent.obj = textContent.arr[1] ? textContent.arr[1] : {}
  rightTextContent.obj = textContent.arr[2] ? textContent.arr[2] : {}

})
</script>
